import { useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import FocusTrap from "focus-trap-react";
import cn from "classnames";
import useMountTransition from "./useMountTransition";
import "./style.css";
import { isSmallScreen } from "../../helpers/screens";

/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/building-a-drawer-component-with-react-portals
 */
const Drawer = ({
  isOpen,
  children,
  className="",
  onClose,
  position = "right",
  size="50",
  minsize="50"
}:any) => {
  // Allow Escape key to dismiss the drawer
  const drawer_mobile_cls = isSmallScreen() ? "drawer_mobile" :"";
  
  useEffect(() => {
    const onKeyPress = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keyup", onKeyPress);
    }

    return () => {
      window.removeEventListener("keyup", onKeyPress);
    };
  }, [isOpen, onClose]);
  if(!isOpen) return null

  return (
        <div
          aria-hidden={isOpen ? "false" : "true"}
          className={cn("drawer-container z-[9999]  ", {
            open: isOpen,
            in:true,
            className
            
          })}
          
        >
          <div 
            className={cn(`drawer bg-white dark:bg-[#111928] ${drawer_mobile_cls}`,position)} 
            role="dialog"
            style={{maxWidth:`${size}%`,minWidth:`${minsize}%`}}
          >
            {children}
          </div>
          <div className="backdrop" onClick={onClose} />
        </div>
  );
};

export default Drawer;
